<script lang="ts">
  import type { AnimationsConfig } from "../declarations/config";
  import { backgroundDimensions } from "../config/dimensions";
  import { BackgroundDimensions } from "../store/AppState";

  export let config: AnimationsConfig;
  export let onLoad: () => void;

  const xRatio = Number(config.coordinates.x) / backgroundDimensions.width;
  const yRatio = Number(config.coordinates.y) / backgroundDimensions.height;
  const widthRatio = Number(config.width) / backgroundDimensions.width;

  let x = 0;
  let y = 0;
  let width = 0;

  const calculateDimensions = () => {
    x = xRatio * $BackgroundDimensions.width;
    y = yRatio * $BackgroundDimensions.height;
    width = widthRatio * $BackgroundDimensions.width;
  };

  window.addEventListener("resize", () => {
    calculateDimensions();
  });
</script>

<div
  class="extra-object-container"
  style={`--top: ${y}px; --left: ${x}px; --z-index: ${config.layer}`}
>
  <img
    class="extra-object"
    on:load={() => onLoad()}
    alt="${config.name}"
    src={`${__PUBLIC_PATH__}images/${config.name}.png`}
    style={`--width: ${width}px`}
  />
</div>

<style>
  .extra-object-container {
    top: var(--top);
    left: var(--left);
    position: absolute;
    z-index: var(--z-index);
  }
  .extra-object {
    width: var(--width);
  }
</style>
